var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "task-config-container",
      on: { "tab-click": _vm.handleTabChange },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "钻石卡申请列表", name: "diamondList" } },
            [
              _c("diamondList", {
                attrs: { activeTab: _vm.activeTab },
                on: { viewDetail: _vm.viewDetail },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeTab == "diamondDetail"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "申请详情", name: "diamondDetail" } },
                [
                  _c("diamondDetail", {
                    attrs: {
                      detail: _vm.detail,
                      activeStep: _vm.activeStep,
                      activeTab: _vm.activeTab,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }